export default function AnalyticsParameters() {
  const params = [
    {
      icon: 'ri-cloud-line',
      title: 'Сбор данных со всех площадок',
      desc: 'Автоматическое подтягивание расходов из Google Ads, Яндекс.Директ, соцсети.',
    },
    {
      icon: 'ri-links-line',
      title: 'Связка с вашей CRM',
      desc: 'Интеграция с Bitrix24, amoCRM или вашей базой данных для отслеживания реальных сделок.',
    },
    {
      icon: 'ri-phone-line',
      title: 'Коллтрекинг (отслеживание телефонных звонков)',
      desc: 'Вы узнаете, с какой конкретно рекламы пришел каждый звонящий клиент.',
    },
    {
      icon: 'ri-dashboard-2-line',
      title: 'Понятный дашборд (информационная панель)',
      desc: 'Единое окно, где вы в реальном времени видите стоимость привлечения одного реального покупателя (CAC) и окупаемость инвестиций (ROI).',
    },
  ];

  return (
    <section className="py-16 sm:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid lg:grid-cols-2 gap-12 sm:gap-16 items-center">
          {/* Left: content */}
          <div>
            <h2 className="text-2xl sm:text-4xl md:text-5xl font-bold text-[#1A2B4C] mb-6 font-['Playfair_Display'] leading-tight">
              Какие параметры Сквозной аналитики настраиваются
            </h2>
            <div className="space-y-5 mt-8">
              {params.map((p, i) => (
                <div key={i} className="flex items-start gap-5 group">
                  <div className="flex-shrink-0 w-13 h-13 w-[52px] h-[52px] bg-[#1A2B4C] group-hover:bg-[#C5A880] rounded-2xl flex items-center justify-center transition-colors duration-300">
                    <i className={`${p.icon} text-2xl text-white`}></i>
                  </div>
                  <div className="flex-1">
                    <h4 className="text-base sm:text-lg font-bold text-[#1A2B4C] mb-1 font-['Montserrat']">{p.title}</h4>
                    <p className="text-sm sm:text-base text-gray-600 leading-relaxed font-['Montserrat'] text-justify">{p.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Right: image + result */}
          <div className="relative">
            <div className="rounded-3xl overflow-hidden">
              <img
                src="https://public.readdy.ai/ai/img_res/cfac9254a05104dc120ec88ec926cbd3.jpg"
                alt="Аналитический дашборд"
                className="w-full h-[280px] sm:h-[380px] lg:h-[500px] object-cover object-top"
              />
            </div>

            {/* Result card — mobile: static block below image */}
            <div className="lg:hidden mt-4 bg-[#1A2B4C] rounded-2xl p-5">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-line text-white text-lg"></i>
                </div>
                <span className="text-[#C5A880] text-sm font-bold font-['Montserrat'] uppercase tracking-wide">Результат</span>
              </div>
              <p className="text-white text-sm font-['Montserrat'] leading-relaxed text-justify">
                <strong>Прозрачный путь клиента:</strong> Вы будете видеть каждое касание — от первого баннера до повторной покупки через год.
              </p>
            </div>

            {/* Result card — desktop: absolute */}
            <div className="hidden lg:block absolute -bottom-6 -left-8 bg-[#1A2B4C] rounded-2xl p-7 max-w-xs shadow-2xl">
              <div className="flex items-center gap-3 mb-3">
                <div className="w-9 h-9 bg-[#C5A880] rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-eye-line text-white text-lg"></i>
                </div>
                <span className="text-[#C5A880] text-sm font-bold font-['Montserrat'] uppercase tracking-wide">Результат</span>
              </div>
              <p className="text-white text-base font-['Montserrat'] leading-relaxed text-justify">
                <strong>Прозрачный путь клиента:</strong> Вы будете видеть каждое касание — от первого баннера до повторной покупки через год.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
